// Seed data: the 3 BCS Forums and their posts/achievements/documents.

export const seedForums = [
  {
    id: "seed-forum-1",
    slug: "socio-civic-political",
    name: "Socio Civic & Political Forum",
    tagline: "Faith in action for a just and participative city",
    description:
      "The Socio Civic & Political Forum encourages members — especially young people — to register as voters and take up civic issues affecting our city and community. The forum networks with more than 15 NGOs across Mumbai and India, engages with municipal and state authorities, and runs sustained campaigns on governance, civic amenities and minority rights.",
    focus_areas: [
      "Voter registration & electoral awareness",
      "Civic issue redressal with the BMC and state bodies",
      "Legal aid for the marginalized with DSLA",
      "Networking with 15+ NGOs across Mumbai and India",
    ],
    icon: "Landmark",
    hero_image:
      "https://images.unsplash.com/photo-1532629345422-7515f3d16bb6?auto=format&fit=crop&w=1600&q=70",
    is_published: true,
    sort_order: 1,
  },
  {
    id: "seed-forum-2",
    slug: "environment",
    name: "Environment Forum",
    tagline: "Caring for creation, one parish at a time",
    description:
      "The Environment Forum promotes green and solar energy, composting, and plastic-waste collection in parishes across the Archdiocese. The Sabha stood at the forefront of protests against the destruction of Aarey Colony and continues to advocate for Mumbai's green spaces, mangroves and coastline.",
    focus_areas: [
      "Solar energy adoption in parishes & institutions",
      "Wet-waste composting and plastic collection drives",
      "Tree plantation & protection of Aarey and mangroves",
      "Laudato Si' awareness programmes",
    ],
    icon: "Leaf",
    hero_image:
      "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?auto=format&fit=crop&w=1600&q=70",
    is_published: true,
    sort_order: 2,
  },
  {
    id: "seed-forum-3",
    slug: "youth-training",
    name: "Youth & Training Forum",
    tagline: "Forming the leaders our community needs tomorrow",
    description:
      "Our academy trains youth for civil services and government placement examinations. In the last two years, trained members have joined the DRI and various government departments — with the IAS as our aim. The forum also runs leadership camps, career guidance sessions and soft-skill workshops across units.",
    focus_areas: [
      "Civil services (UPSC / MPSC) coaching academy",
      "Government placement examination training",
      "Career guidance & scholarship facilitation",
      "Leadership formation camps for unit youth",
    ],
    icon: "GraduationCap",
    hero_image:
      "https://images.unsplash.com/photo-1523580494863-6f3031224c94?auto=format&fit=crop&w=1600&q=70",
    is_published: true,
    sort_order: 3,
  },
];

export const seedForumPosts = [
  {
    id: "seed-fp-1",
    forum_slug: "socio-civic-political",
    title: "City-wide voter registration campaign crosses 5,000 new registrations",
    post_type: "campaign",
    excerpt:
      "Units across all deaneries participated in the pre-election voter registration push, with special desks after Sunday masses.",
    body:
      "The Socio Civic & Political Forum coordinated a city-wide voter registration campaign across 40+ units. Special registration desks were set up after Sunday masses, and volunteers assisted first-time voters with Form 6 submissions. The campaign crossed 5,000 new registrations, with the highest numbers reported from the Bandra, Borivali and Thane deaneries.",
    image_url: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=1200&q=70",
    created_at: "2026-04-02",
    is_published: true,
    is_featured: true,
  },
  {
    id: "seed-fp-2",
    forum_slug: "socio-civic-political",
    title: "Free legal aid clinics with DSLA expand to 12 parishes",
    post_type: "achievement",
    excerpt:
      "In collaboration with the District Legal Services Authority, retired judges provide free legal advice to marginalized members of society.",
    body:
      "Our legal aid initiative, run in collaboration with DSLA (District Legal Services Authority), has expanded to 12 parishes. Retired judges and empanelled advocates provide free legal advice on tenancy, documentation, senior citizen rights and family matters to marginalized members of our society.",
    image_url: "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=1200&q=70",
    created_at: "2026-03-10",
    is_published: true,
    is_featured: true,
  },
  {
    id: "seed-fp-3",
    forum_slug: "environment",
    title: "Solar rooftop project commissioned at three parish schools",
    post_type: "achievement",
    excerpt:
      "The forum facilitated solar installations that will cut electricity costs by up to 40% for three parish-run schools.",
    body:
      "Working with parish managements and empanelled vendors, the Environment Forum facilitated rooftop solar installations at three parish schools. The combined capacity of 75 kW is expected to reduce electricity costs by up to 40% and serves as a model for other institutions in the Archdiocese.",
    image_url: "https://images.unsplash.com/photo-1509391366360-2e959784a276?auto=format&fit=crop&w=1200&q=70",
    created_at: "2026-02-20",
    is_published: true,
    is_featured: true,
  },
  {
    id: "seed-fp-4",
    forum_slug: "environment",
    title: "Plastic collection drive gathers 1.2 tonnes across 20 units",
    post_type: "campaign",
    excerpt:
      "Lenten plastic-waste collection drive sees record participation from parish youth groups.",
    body:
      "The annual Lenten plastic collection drive saw 20 units gather over 1.2 tonnes of single-use plastic, which was channelled to authorised recyclers. Parish youth groups led door-to-door awareness in housing societies.",
    image_url: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?auto=format&fit=crop&w=1200&q=70",
    created_at: "2026-03-30",
    is_published: true,
    is_featured: false,
  },
  {
    id: "seed-fp-5",
    forum_slug: "youth-training",
    title: "Two academy alumni clear government placement examinations",
    post_type: "achievement",
    excerpt:
      "Trained members have joined the DRI and various government departments — with the IAS as our aim.",
    body:
      "We are proud to announce that two alumni of our civil services academy have cleared their respective government placement examinations and joined the DRI and the state revenue department. The academy continues its weekend batches with faculty support from serving and retired officers.",
    image_url: "https://images.unsplash.com/photo-1523580494863-6f3031224c94?auto=format&fit=crop&w=1200&q=70",
    created_at: "2026-01-25",
    is_published: true,
    is_featured: true,
  },
  {
    id: "seed-fp-6",
    forum_slug: "youth-training",
    title: "Leadership camp at Khandala for 80 unit youth representatives",
    post_type: "update",
    excerpt:
      "A three-day residential camp focused on public speaking, civic literacy and servant leadership.",
    body:
      "Eighty youth representatives from across deaneries attended the annual leadership camp at Khandala. Sessions covered public speaking, civic literacy, parliamentary procedure and servant leadership rooted in Catholic social teaching.",
    image_url: "https://images.unsplash.com/photo-1511632765486-a01980e01a18?auto=format&fit=crop&w=1200&q=70",
    created_at: "2025-12-12",
    is_published: true,
    is_featured: false,
  },
];

export const seedForumDocuments = [
  {
    id: "seed-fd-1",
    forum_slug: "socio-civic-political",
    title: "Voter Registration — Form 6 Guide (PDF)",
    file_url: "#",
    file_type: "pdf",
  },
  {
    id: "seed-fd-2",
    forum_slug: "environment",
    title: "Parish Solar Adoption Handbook (PDF)",
    file_url: "#",
    file_type: "pdf",
  },
  {
    id: "seed-fd-3",
    forum_slug: "youth-training",
    title: "Civil Services Academy — Admission Form (PDF)",
    file_url: "#",
    file_type: "pdf",
  },
];
